import classnames from "classnames";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import Sidebar from "./Sidebar";
import Info from "./Info";
import Teams from "./Teams";
import Members from "./Members";
import Schedules from "./Schedules";

import styles from "./Profile.module.scss";

const Profile = ({ isLoggedIn }) => {
  const [active, setActive] = useState("my_info");
  const [fullWidth, setFullWidth] = useState(false);
  const permissions = useSelector((state) => state.permissions);

  // If no profile permissions at all, redirect to home
  if (!(
    permissions?.profile?.my_info ||
    permissions?.profile?.teams ||
    permissions?.profile?.team_members ||
    permissions?.profile?.schedules ||
    permissions?.profile?.settings
  )) {
    return <Navigate to="/" />;
  }

  // If current active section is not allowed, switch to the first allowed section
  if (!permissions?.profile?.[active]) {
    const firstAllowedSection = ["my_info", "teams", "team_members", "schedules", "settings"].find(
      section => permissions?.profile?.[section]
    );
    if (firstAllowedSection) {
      setActive(firstAllowedSection);
    }
  }

  return (
    <>
      <div className={styles.container}>
        <Sidebar setActive={setActive} active={active} />
        {active === "my_info" && permissions?.profile?.my_info && (
          <div className={styles.wrapper}>
            <Info isLoggedIn={isLoggedIn} />
          </div>
        )}
        {active === "teams" && permissions?.profile?.teams && (
          <div className={styles.content}>
            <Teams isLoggedIn={isLoggedIn} />
          </div>
        )}
        {active === "team_members" && permissions?.profile?.team_members && (
          <div
            className={classnames(
              styles.content,
              fullWidth ? styles.fullWidth : ""
            )}
          >
            <Members setFullWidth={setFullWidth} />
          </div>
        )}
        {active === "schedules" && permissions?.profile?.schedules && (
          <div className={styles.content}>
            <Schedules isLoggedIn={isLoggedIn} />
          </div>
        )}
      </div>
    </>
  );
};

export default Profile;
